import React from "react";
import {
  connect,
} from "react-redux";
import {
  applyMiddleware,
  bindActionCreators,
  compose,
  createStore,
} from "redux";
import {
  thunk,
} from "redux-thunk";

import {
  createRouterMiddleware,
  createRouterReducer,
} from "App/legacy/lagunovskyReduxReactRouter";
import {
  createBrowserHistory,
} from "history";
import * as actionExports from "State/actions";
import {
  tokenStore,
} from "CommonCore/apifetch";

import _ from "lodash";

const actions = _.pickBy(actionExports, _.isFunction);

export const history = createBrowserHistory();
history.listen(() => window.scroll(0, 0));

function inlineAction(state = {}, action) {
  if (action.type.startsWith("INLINE:")) {
    state = _.extend({}, state);
    let reverts;
    const modifies = _.isString(action.modifies) ? [action.modifies] : action.modifies;
    if (_.isPlainObject(modifies)) {
      _.keys(modifies).forEach(key => {
        const oldValue = _.get(state, key);
        let value = oldValue;
        switch (modifies[key]) {
          case "deep":
            value = _.cloneDeep(value);
            break;
          case "shallow":
            value = _.clone(value);
            break;
          case "discard":
            value = undefined;
            break;
          case "deep+check":
            value = _.cloneDeep(value);
            if (oldValue) {
              (reverts || (reverts = {}))[key] = oldValue;
            }
            break;

          default: console.assert(!`Invalid 'modifies' value ${ modifies[key] }`);
        }
        _.set(state, key, value);
      });
    } else if (_.isArray(modifies)) {
      modifies.forEach(key => _.set(state, key, _.cloneDeep(_.get(state, key))));
    }
    action.apply(state);

    if (reverts) {
      _.forOwn(reverts, (oldValue, key) => {
        const newValue = _.get(state, key);
        _.forOwn(newValue, (newField, field) => {
          if (_.isEqual(newField, oldValue[field])) {
            newValue[field] = oldValue[field];
          }
        });
      });
    }
  }
  return state;
}

function clearAction(state = {}, action) {
  if (action.type === "CLEAR") {
    return {
      router: state.router,
    };
  }
  return state;
}

function createRootReducer(...reducers) {
  const routerReducer = createRouterReducer(history);
  const combinedReducers = composeReducers(reducers);
  return (state, action) => {
    let nextState = {};

    // call combined reducers
    nextState = combinedReducers(state, action);

    // call router reducer with nextState because the combined reducers might have modified router
    nextState.router = routerReducer(nextState.router, action);
    return nextState;
  };
}

function composeReducers(reducers) {
  return (state, action) => reducers.reduce((s, r) => r(s, action), state);
}

let composeEnhancers = compose;
// eslint-disable-next-line
if (typeof process !== "undefined" && process.env) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}

const rootReducer = createRootReducer(inlineAction, clearAction);

export const store = createStore(
  rootReducer,
  {
    dashboardMenuCollapsed: tokenStore._get("dashboardMenuCollapsed") === "true",
    // TODO NIKITA ROUTING
    pathname: tokenStore._get("pathname"),
  },
  composeEnhancers(applyMiddleware(createRouterMiddleware(history), thunk)),
);

export function consoleLog(...args) {
  return store.dispatch(actions.consoleLog(...args));
}

export function applyStore(args, mapDispatch, customMapState, mergeProps) {
  const mapState = (state, props) => {
    const augmentedProps = _.assign({}, props);
    const excerpt = {};
    args.forEach(a => {
      if (_.isFunction(a)) {
        const n = a.__property;
        const r = a(state, augmentedProps);
        if (r !== undefined) {
          augmentedProps[n] = r;
          excerpt[n] = r;
        }
      } else {
        const split = a.split(".");
        const n = split[split.length - 1];
        const r = augmentedProps[n] || _.get(state, a);
        if (r !== undefined) {
          augmentedProps[n] = r;
          excerpt[n] = r;
        }
      }
    });
    if (customMapState) {
      _.assign(excerpt, customMapState(state, augmentedProps));
    }
    return excerpt;
  };
  return Component => {
    const dispatchConnector = connect(
      undefined,
      dispatch => _.assign(
        { dispatch },
        bindActionCreators(actions, dispatch),
        mapDispatch && mapDispatch(dispatch),
      ),
    );
    const stateConnector = connect(
      mapState,
      undefined,
      mergeProps,
    );
    const connectedComponent = dispatchConnector(stateConnector(Component));
    delete connectedComponent.displayName;
    return connectedComponent;
  };
}

export default function _store(...args) {
  if (_.some(args, a => a.property)) {
    console.warn(`got stragglers`);
  }
  return _.isFunction(args[0]) && !args[0].__property ? applyStore([])(args[0]) : applyStore(args);
}

export function deferredExecute(func, ...storeArgs) {
  return Component => {
    @_store(...storeArgs)
    class Mounter extends React.Component {
      componentDidMount() {
        setTimeout(() => func(this.props), 0);
      }

      componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
          setTimeout(() => func(this.props), 0);
        }
      }
      render() {
        return <Component {...this.props} />;
      }
    }
    return Mounter;
  };
}
